<template>
  <div class="screenView">
    <PageHeader/>
    <div class="mainContent">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import PageHeader from '../components/PageHeader'
export default {
  components: {
    PageHeader
  }
}
</script>
<style lang="less">
@import url('../style/index.less');
.screenView{
  height: 100%;
  display: flex;
  flex-direction: column;
  .mainContent{
    flex: 1;
    background-color: @pageBgColor;
    overflow: hidden;
  }
}
</style>